import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSWRConfig } from 'swr';
import { useTranslation } from 'react-i18next';
import container from 'src/container';
import { supportModeService } from 'src/services/supportMode.service';
import { UserActions } from 'src/state/_actions';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';
import { useNotification } from './Notification/useNotfication';

const {
    cradle: { munduClient },
} = container;

export const SupportModeBanner = () => {
    const user = useSignedInUser();
    const supportMode = user?.supportMode;
    const [isExiting, setIsExiting] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const notify = useNotification();
    const { mutate } = useSWRConfig();
    const { t } = useTranslation();

    if (!supportMode) return null;

    const exitSupportMode = async () => {
        const storedSession = supportModeService.get();
        let sessionEnded = false;
        setIsExiting(true);
        supportModeService.clear();

        try {
            if (storedSession) {
                await munduClient.endSupportSession(storedSession.token);
                sessionEnded = true;
            }
            const adminUser = await munduClient.getUser();
            dispatch(UserActions.setUser(adminUser));
            await mutate(() => true, undefined, { revalidate: false });
            history.replace(
                `/app/admin/organization/${supportMode.organizationId}`,
            );
        } catch (error) {
            if (storedSession && !sessionEnded) {
                supportModeService.set(storedSession);
            }
            if (error instanceof Error) notify(error.message, true);
        } finally {
            setIsExiting(false);
        }
    };

    return (
        <aside className="flex max-w-[min(44rem,calc(100vw-10rem))] items-center gap-4 rounded-xl border border-woodyBrown bg-vanillaYellow px-4 py-2 text-woodyBrown shadow-sm">
            <div className="min-w-0">
                <p className="font-semibold truncate">
                    {t('supportMode.title', {
                        organization: supportMode.organizationName,
                    })}
                </p>
                <p className="text-xs opacity-70">
                    {t('supportMode.readOnly')}
                </p>
            </div>
            <button
                type="button"
                className="shrink-0 rounded-full border border-woodyBrown px-3 py-1 text-sm font-medium hover:bg-woodyBrown hover:text-white disabled:opacity-50"
                onClick={exitSupportMode}
                disabled={isExiting}
            >
                {isExiting ? t('supportMode.exiting') : t('supportMode.exit')}
            </button>
        </aside>
    );
};
